import {useRef} from 'react'
import {logger} from 'tizra'

const log = logger('quickstart/hooks/useMax')

export const useMax = i => {
  const ref = useRef()
  if (
    Number.isFinite(i) &&
    (!Number.isFinite(ref.current) || i > ref.current)
  ) {
    ref.current = i
  }
  return ref.current
}
